module.exports = __webpack_public_path__ + "img/appraisementHover.ae41c2c3.png";